<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-Post-4_approval-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-Post-4_approval-xs" class="g-artboard" style="">
      <div style="padding: 0 0 85.4545% 0;"></div>
      <div
        id="g-Post-4_approval-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/Post-4_approval-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-md g-aiAbs"
        style="top:0.3546%;left:-0.0085%;width:15.4545%;"
      >
        <p>All U.S. adults</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-md g-aiAbs"
        style="top:6.0284%;right:73.6364%;width:6.9697%;"
      >
        <p class="g-pstyle0">Yes</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-md g-aiAbs"
        style="top:6.0284%;left:41.0606%;margin-left:-11.6667%;width:23.3333%;"
      >
        <p class="g-pstyle1">Don&rsquo;t know</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-md g-aiAbs"
        style="top:6.0284%;left:58.1492%;width:6.9697%;"
      >
        <p class="g-pstyle2">No</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-md g-aiAbs"
        style="top:14.539%;right:73.6364%;width:10.9091%;"
      >
        <p class="g-pstyle3">27%</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-md g-aiAbs"
        style="top:14.539%;left:58.1492%;width:10.303%;"
      >
        <p class="g-pstyle4">43%</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-md g-aiAbs"
        style="top:32.9787%;left:-0.0085%;width:40.9091%;"
      >
        <p class="g-pstyle2">By party affiliation</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-md g-aiAbs"
        style="top:40.4255%;left:-0.0085%;width:27.8788%;"
      >
        <p>Republicans</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-md g-aiAbs"
        style="top:48.9362%;right:44.5455%;width:12.7273%;"
      >
        <p class="g-pstyle3">55%</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-md g-aiAbs"
        style="top:48.9362%;left:87.399%;width:10.9091%;"
      >
        <p class="g-pstyle4">13%</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-md g-aiAbs"
        style="top:61.3475%;left:-0.0085%;width:23.9394%;"
      >
        <p>Democrats</p>
      </div>
      <div
        id="g-ai0-12"
        class="g-md g-aiAbs"
        style="top:70.5674%;left:25.2743%;width:13.6364%;"
      >
        <p class="g-pstyle4">74%</p>
      </div>
      <div
        id="g-ai0-13"
        class="g-md g-aiAbs"
        style="top:70.5674%;right:93.3072%;width:6.3636%;"
      >
        <p class="g-pstyle3">7%</p>
      </div>
      <div
        id="g-ai0-14"
        class="g-md g-aiAbs"
        style="top:82.6241%;left:-0.0085%;width:36.3636%;"
      >
        <p>Others</p>
      </div>
      <div
        id="g-ai0-15"
        class="g-md g-aiAbs"
        style="top:91.4894%;right:81.5152%;width:10.9091%;"
      >
        <p class="g-pstyle3">19%</p>
      </div>
      <div
        id="g-ai0-16"
        class="g-md g-aiAbs"
        style="top:91.4894%;left:56.1903%;width:12.7273%;"
      >
        <p class="g-pstyle4">44%</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660}
    <div id="g-Post-4_approval-md" class="g-artboard" style="">
      <div style="padding: 0 0 39.697% 0;"></div>
      <div
        id="g-Post-4_approval-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/Post-4_approval-md.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-md g-aiAbs"
        style="top:0%;left:0.005%;width:17.1212%;"
      >
        <p>All U.S. adults</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-md g-aiAbs"
        style="top:0%;right:73.5809%;width:4.3939%;"
      >
        <p class="g-pstyle0">Yes</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-md g-aiAbs"
        style="top:0%;left:42.5097%;margin-left:-8.5606%;width:17.1212%;"
      >
        <p class="g-pstyle1">Don&rsquo;t know</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-md g-aiAbs"
        style="top:0%;left:58.1578%;width:4.3939%;"
      >
        <p class="g-pstyle2">No</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-md g-aiAbs"
        style="top:9.1603%;right:73.5619%;width:6.5152%;"
      >
        <p class="g-pstyle3">27%</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-md g-aiAbs"
        style="top:9.1603%;left:58.1578%;width:6.5152%;"
      >
        <p class="g-pstyle4">43%</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-md g-aiAbs"
        style="top:29.0076%;left:0.005%;width:20.7576%;"
      >
        <p class="g-pstyle2">By party affiliation</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-md g-aiAbs"
        style="top:36.6412%;left:0.005%;width:14.697%;"
      >
        <p>Republicans</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-md g-aiAbs"
        style="top:46.1832%;right:44.6089%;width:6.5152%;"
      >
        <p class="g-pstyle3">55%</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-md g-aiAbs"
        style="top:46.1832%;left:87.4051%;width:6.5152%;"
      >
        <p class="g-pstyle4">13%</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-md g-aiAbs"
        style="top:59.542%;left:0.005%;width:14.697%;"
      >
        <p>Democrats</p>
      </div>
      <div
        id="g-ai1-12"
        class="g-md g-aiAbs"
        style="top:69.4656%;right:93.1422%;width:6.5152%;"
      >
        <p class="g-pstyle3">7%</p>
      </div>
      <div
        id="g-ai1-13"
        class="g-md g-aiAbs"
        style="top:69.4656%;left:25.2856%;width:6.5152%;"
      >
        <p class="g-pstyle4">74%</p>
      </div>
      <div
        id="g-ai1-14"
        class="g-md g-aiAbs"
        style="top:82.4427%;left:0.005%;width:14.697%;"
      >
        <p>Others</p>
      </div>
      <div
        id="g-ai1-15"
        class="g-md g-aiAbs"
        style="top:91.9847%;right:81.4558%;width:6.5152%;"
      >
        <p class="g-pstyle3">19%</p>
      </div>
      <div
        id="g-ai1-16"
        class="g-md g-aiAbs"
        style="top:91.9847%;left:56.1991%;width:6.5152%;"
      >
        <p class="g-pstyle4">44%</p>
      </div>
    </div>
  {/if}
</div>

<!-- End ai2html - 2026-03-02 18:22 -->

<!-- Generated by ai2html v0.100.0 - 2026-03-02 18:22 -->
<!-- ai file: Post-4_approval.ai -->
<style lang="scss">
  #g-Post-4_approval-box,
  #g-Post-4_approval-box .g-artboard {
    margin: 0 auto;
  }
  #g-Post-4_approval-box p {
    margin: 0;
  }
  #g-Post-4_approval-box .g-aiAbs {
    position: absolute;
  }
  #g-Post-4_approval-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-Post-4_approval-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-4_approval-xs {
    position: relative;
    overflow: hidden;
  }
  #g-Post-4_approval-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-Post-4_approval-xs .g-pstyle0 {
    font-weight: 700;
    text-align: right;
  }
  #g-Post-4_approval-xs .g-pstyle1 {
    text-align: center;
  }
  #g-Post-4_approval-xs .g-pstyle2 {
    font-weight: 700;
  }
  #g-Post-4_approval-xs .g-pstyle3 {
    font-weight: 700;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-Post-4_approval-xs .g-pstyle4 {
    font-weight: 700;
    color: rgb(255, 255, 255);
  }
  #g-Post-4_approval-md {
    position: relative;
    overflow: hidden;
  }
  #g-Post-4_approval-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-Post-4_approval-md .g-pstyle0 {
    font-weight: 700;
    text-align: right;
  }
  #g-Post-4_approval-md .g-pstyle1 {
    text-align: center;
  }
  #g-Post-4_approval-md .g-pstyle2 {
    font-weight: 700;
  }
  #g-Post-4_approval-md .g-pstyle3 {
    font-weight: 700;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-Post-4_approval-md .g-pstyle4 {
    font-weight: 700;
    color: rgb(255, 255, 255);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
